export const NOTIFY = {
    ARTIFACT_SAVE: {
        SUCCESS:"Artifact save success",
        FAILED:"Artifact save failed",
    },
    ARTIFACT_DELETE: {
        SUCCESS:"Artifact delete success",
        FAILED:"Artifact delete failed",
    },
    APPLICATION_SAVE: {
        SUCCESS:"Your application has been submitted",
        FAILED:"We had a problem saving your application",
    },
    APPLICATION_REJECT: {
        SUCCESS:"Application has been requested for resubmit and the applicant notified",
        FAILED:"We had a problem saving your application",
    },
    APPLICATION_DENY: {
        SUCCESS:"Application has been requested for deny",
        FAILED:"We had a problem saving your application",
    },
    APPLICATION_DELETE: {
        SUCCESS:"Application has been deleted",
        FAILED:"We had a problem deleting application",
    },
    NOTIFICATION: {
        SUCCESS:"Notification send success",
        FAILED:"Notification send failed",
    },
    NOTE: {
        SUCCESS:"Note send success",
    }
};
